import React from 'react';

import { useDispatch } from 'react-redux';

import Box from '@amzn/meridian/box';
import AppliedFilterTags from 'src/components/shared/appliedFilterTags/appliedFilterTags';
import { removeTagAndUpdateFilter } from 'src/store/jobConfigPageSlice/jobConfigPageSlice';
import { useAppSelector } from 'src/store/store';

import RestrictionFormConfigurationFilterSheet from './restrictionFormConfigurationFilterSheet/restrictionFormConfigurationFilterSheet';
import RestrictionFormPagination from './restrictionFormPagination/restrictionFormPagination';
import RestrictionFormTable from './restrictionFormTable/restrictionFormTable';
import TopOptions from './topOptions/topOptions';

// **** Components **** //

/**
 * Default component.
 */
const RestrictionFormsTableContainer = () => {
  const dispatch = useDispatch();
  const { restrictionFormTableFilterTags } = useAppSelector((state) => state.regionTasksConfigPage);

  return (
    <Box>
      <AppliedFilterTags
        filterTags={restrictionFormTableFilterTags}
        onDismissTag={(tag) => dispatch(removeTagAndUpdateFilter(tag))}
        tag-data-testid="restriction-form-table__applied-filter-tag"
      />
      <TopOptions />
      <RestrictionFormTable />
      <RestrictionFormPagination />
      <RestrictionFormConfigurationFilterSheet />
    </Box>
  );
};

// **** Export **** //

export default RestrictionFormsTableContainer;
